import { Checkbox } from '@chakra-ui/react';
import { useCallback } from 'react';

import type { TableRow } from '../../TableSelectionProvider/TableSelectionProvider';

interface SelectAllCheckboxProps {
  tableData: TableRow[];
  selectedRows?: TableRow[];
  onRowSelectionChange: (rows: TableRow[]) => void;
}

export const SelectAllCheckbox = ({
  tableData,
  selectedRows,
  onRowSelectionChange,
}: SelectAllCheckboxProps) => {
  const isAllSelected =
    (selectedRows?.length ?? 0) === tableData.length && tableData.length > 0;
  const isIndeterminate =
    (selectedRows?.length ?? 0) > 0 &&
    (selectedRows?.length ?? 0) < tableData.length;

  const handleSelectAll = useCallback(() => {
    if (isAllSelected) {
      onRowSelectionChange([]);
    } else {
      onRowSelectionChange(tableData);
    }
  }, [isAllSelected, onRowSelectionChange, tableData]);

  return (
    <Checkbox
      aria-label="Select all rows"
      isChecked={isAllSelected}
      isIndeterminate={isIndeterminate}
      colorScheme="green"
      onChange={handleSelectAll}
      size="md"
      sx={{
        justifyContent: 'center',
        height: '26px',
      }}
    />
  );
};
